import { IDatabase } from '../types/IDatabase';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IDatasourceUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { INamedItem } from '../types/resourceParts';
import { Request } from './Request';

export interface IGetDatabasesParams extends IGetItemsParams {
}

export interface IGetDatabasesResult extends IGetItemsResult {
  databases?: IDatabase[];
  users?: IUser[];
}

export class GetDatabasesRequest extends Request<IGetDatabasesParams, IGetDatabasesResult> {
  constructor(params: IGetDatabasesParams) {
    super('getDatabases', params);
  }
}